import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { WMS1140_R01DetailDto } from "../Dto_WMS1140_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { isSubcontractMaterialInoutClass, normalizeWMS1140DetailRow } from "../Constants_WMS1140_R01";
interface UseWMS1140_R01CellChangeProps {
	WMS1140_R01DetailList: WMS1140_R01DetailDto[];
	originalWMS1140_R01DetailList: WMS1140_R01DetailDto[];
	updateWMS1140_R01DetailList: (index: number, data: WMS1140_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<WMS1140_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
	customCd?: string;
	inoutClass?: string;
}

export function useWMS1140_R01CellChange({
	WMS1140_R01DetailList,
	originalWMS1140_R01DetailList,
	updateWMS1140_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
	customCd,
	inoutClass,
}: UseWMS1140_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const WMS1140R01Config = createModuleConfig.WMS1140();
	const isSubcontractInout = isSubcontractMaterialInoutClass(inoutClass);

		 // PROGRAM 공통코드에서 ITEM_POPUP_SEARCH의 ref01 값으로 필터 사용 여부 결정
		 const { programList } = useCommonCodeStore();
		 const useCustomCdFilter =
			 programList.find(c => c.minorCd === 'ITEM_POPUP_SEARCH')?.ref01 === 'Y';

	const itemCdBaseConfig = WMS1140R01Config.fieldConfig.codeSearchFields!.itemCd;
	const { itemCost: _itemCost, ...responseMappingWithoutCost } = itemCdBaseConfig.responseMapping;

	const fieldConfigWithSearch = {
		...WMS1140R01Config.fieldConfig,
		codeSearchFields: {
			...WMS1140R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...itemCdBaseConfig,
				responseMapping: isSubcontractInout
					? responseMappingWithoutCost
					: itemCdBaseConfig.responseMapping,
				searchFilters: () =>
					useCustomCdFilter && customCd?.trim() ? { customCd: customCd.trim() } : undefined,
				searchFunction: searchExactItemCode,
				canOpenModal: (row: WMS1140_R01DetailDto) => !!row?.inserted,
			},
		},
	};

	const calculateAmount = (data: WMS1140_R01DetailDto): WMS1140_R01DetailDto => {
		return normalizeWMS1140DetailRow(data, inoutClass);
	};

	return useCommonDetailTableHandlers<WMS1140_R01DetailDto>({
		detailList: WMS1140_R01DetailList,
		updateDetailList: updateWMS1140_R01DetailList,
		originalDetailList: originalWMS1140_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: WMS1140R01Config.codeSearchConfig,
		calculateAmount,
	});
}
